import { Injectable, inject } from '@angular/core';
import { QueryEntity } from '@datorama/akita';

import { PayrollState, PayrollStore } from './payroll.store';

@Injectable({
  providedIn: 'root',
})
export class PayrollQuery extends QueryEntity<PayrollState> {
  protected store: PayrollStore;

  constructor() {
    const store = inject(PayrollStore);

    super(store);

    this.store = store;
  }
}
